import ReviewsQueryBase from "@apps/reviews/queries/ReviewsQueryBase";

import ProductReviewsMiniSliderWidgetReviewsStore from "../stores/ProductReviewsMiniSliderWidgetReviewsStore";

class ProductReviewsMiniSliderWidgetReviewsQuery extends ReviewsQueryBase {
    constructor(store: ProductReviewsMiniSliderWidgetReviewsStore) {
        super(store);
    }
}

export default ProductReviewsMiniSliderWidgetReviewsQuery;
